import React from "react";
import { TextContainer } from "../../pages/landing/index.styled";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay, Pagination } from "swiper";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import sliderImgLeft from "../../assets/images/sliderImgLeft.png";
import sliderImgRight from "../../assets/images/sliderImgRight.png";
import signal from "../../assets/images/signal.svg";

const Slider = () => {
  return (
    <Swiper
      modules={[Autoplay, Pagination]}
      autoplay={{ delay: 5000 }}
      pagination={{ clickable: true }}
      className="slider-wrapper"
    >
      <SwiperSlide className="slide">
        <div className="arrow-wrapper-right">
          <img src={sliderImgRight} alt="slider logo" />
        </div>
        <div className="slider-content">
          <div className="img-wrapper">
            <img src={signal} alt="signal icon" />
          </div>
          <h3>سیگنال</h3>
          <p>راهنمای سرمایه گذاری</p>
          <TextContainer maxW="480px">
            <p>
              پس از افزودن وب سرویس آواشو به مجموعه امکانات پلتفرم سیگنال،
              بازخوردهای خوب بسیاری از کاربران دریافت کردیم. به لطف این فناوری،
              تاکنون تمامی کاربران توانسته‌اند با تجربه یک رابط کاربری
              فوق‌العاده منعطف، از دانشی که پیرامون بازار سرمایه تولید می‌کردیم،
              استفاده کنند.
            </p>
          </TextContainer>
        </div>
        <div className="arrow-wrapper-left">
          <img src={sliderImgLeft} alt="slider" />
        </div>
      </SwiperSlide>
      <SwiperSlide className="slide">
        <div className="arrow-wrapper-right">
          <img src={sliderImgRight} alt="slider" />
        </div>
        <div className="slider-content">
          <div className="img-wrapper hoshio">
            <img src={'hooshio.png'} alt="signal icon" />
          </div>
          <h3 className="hoshio" >هوشیو</h3>
          <p>پایگاه جامع هوش مصنوعی</p>
          <TextContainer maxW="480px" >
            <p>
            به‌کارگیری وب سرویس آواشو باعث شده تا افراد زیادی به مخاطب هوشیو تبدیل شوند. 
            این فناوری، محدودیت‌های استفاده از هوشیو را از میان برداشته، آن را به یک وب‌سایت داینامیک و
             پیشرفته مبدل ساخته و رابط کاربری پلتفرم خبری ما را هیجان‌انگیزتر کرده است.
            </p>
          </TextContainer>
        </div>
        <div className="arrow-wrapper-left">
          <img src={sliderImgLeft} alt="slider" />
        </div>
      </SwiperSlide>
    </Swiper>
  );
};

export default Slider;
